module.exports = __webpack_public_path__ + "static/media/spin-desktop.1ef6da7e.jpg";